import { useState } from "react";
import { usePlayer } from "../app/services";

export function ConnectMusic({ onConnected }: { onConnected: () => void }) {
  const { music } = usePlayer();
  const [error, setError] = useState<string | null>(null);

  async function connect() {
    setError(null);
    try {
      await music.authorize();
      if (music.isAuthorized) onConnected();
    } catch {
      setError("Apple Music wasn't connected. Try again.");
    }
  }

  return (
    <main className="gate">
      <div className="gate-card">
        <img src="/icon.png" alt="" className="gate-icon" />
        <h1>Connect Apple Music</h1>
        <p className="muted">
          The station plays tracks from your Apple Music subscription, the same way the phone does.
          Sign in with your Apple ID in the window that opens.
        </p>
        {error && <p className="error">{error}</p>}
        <button type="button" className="primary" onClick={() => void connect()}>
          Connect Apple Music
        </button>
      </div>
    </main>
  );
}
